import React, { Fragment, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useHistory } from "react-router-dom";
import Manual from './game/Manual';




const Otazka = () => {

    

    let history = useHistory();

    const  Start= () => {
        const element = document.querySelector('.play-btn');
        element.classList.add('animate__animated', 'animate__bounceOut');
        setTimeout(() => { history.push("/play/teampicker"); }, 600);
	};
    
    const  Project= () => {
        const element = document.querySelector('.project-btn');
        element.classList.add('animate__animated', 'animate__bounceOut');
        setTimeout(() => { history.push("/project"); }, 600);
	};

    const  Manual= () => {
        const element = document.querySelector('.project-btn');
     //   element.classList.add('animate__animated', 'animate__bounceOut');
        setTimeout(() => { history.push("/manual"); }, 600);
	};

    const  Singleplayer= () => {
        const element = document.querySelector('.project-btn');
     //   element.classList.add('animate__animated', 'animate__bounceOut');
        setTimeout(() => { history.push("/play/singleplayer"); }, 600);
	};
    return (
        <Fragment>
        <Helmet><title>Eduraw</title></Helmet>
        <div id="home">
            
            <section className='main-home'>
               
                <div className='logo-container'>
                  <img className='logo' src={require('../img/logo-trans.png')} alt="alt"/>
                </div>
                <div className='h1-container'>
                    <p className='h1'>EduRAW</p>
                </div>
                <div className="play-btn-container">
                    <div className="project-btn-container animate__animated animate__fadeInUp ">
                        <div className='play-btn' onClick={() => Start()}>Start Game</div>
                    </div>
                </div>
                <div className="project-btn-container animate__animated animate__fadeInUp ">
                        <div className='project-btn' onClick={() => Singleplayer()}>Singleplayer</div>
                </div>
                <div className="project-btn-container animate__animated animate__fadeInUp ">
                        <div className='project-btn' onClick={() => Project()}>More about</div>
                </div>
                <div className="project-btn-container animate__animated animate__fadeInUp ">
                        <div className='project-btn' onClick={() => Manual()}>How to play</div>
                </div>

                <div className="logo-project-container">
                    <img className='logo-project' src={require('../img/rm.png')} alt="alt"/>
                    <img className='logo-project' src={require('../img/fberg.png')} alt="alt"/>
                </div>

                
            </section> 

            
        </div>  
      

    </Fragment>


   
    );
};


export default Otazka;




